import { AssinaturaStatusResponse } from "../types/billing.types";
import { PATHS } from "../app/paths";

/** Mesma tupla de `SincronizadorBilling._STATUS_COM_ACESSO` no backend. */
const STATUS_COM_ACESSO = new Set(["active", "trialing", "past_due", "unpaid"]);

const FLAG_BILLING_DESATUALIZADO = "billingPrecisaAtualizar";

/** Depois do Stripe o GET /billing/assinatura ainda pode vir sem plano.
 *  ProtectedRoute não pode tratar esse billing como "já hidratado". */
export function marcarBillingDesatualizado(): void {
  sessionStorage.setItem(FLAG_BILLING_DESATUALIZADO, "1");
}

export function billingEstaDesatualizado(): boolean {
  return sessionStorage.getItem(FLAG_BILLING_DESATUALIZADO) === "1";
}

export function limparBillingDesatualizado(): void {
  sessionStorage.removeItem(FLAG_BILLING_DESATUALIZADO);
}

/**
 * Intenção de checkout deixada no sessionStorage pelo fluxo
 * landing → /assinar → Auth0. Se ninguém limpar depois do pagamento,
 * o próximo login restaura `/assinar?plano=...` e o POST /checkout
 * responde 409 — a tela "já tem assinatura" em vez do app.
 */
export function limparIntencaoDeCheckout(): void {
  const returnTo = sessionStorage.getItem("returnTo");
  if (returnTo && ehRotaDeCheckout(returnTo)) {
    sessionStorage.removeItem("returnTo");
  }
  sessionStorage.removeItem("planoPendente");
}

export function temAssinaturaAtiva(
  billing: AssinaturaStatusResponse | null | undefined,
): boolean {
  const status = billing?.plano?.status;
  return Boolean(status && STATUS_COM_ACESSO.has(status));
}

/** Sem assinatura vigente (cancelada, expirada ou nunca assinou):
 *  Portal do Stripe não serve para reassinar — vai para /planos. */
export function precisaEscolherPlano(
  billing: AssinaturaStatusResponse | null | undefined,
): boolean {
  return !temAssinaturaAtiva(billing);
}


export function destinoAposLogin(
  returnTo: string | null | undefined,
  billing: AssinaturaStatusResponse | null | undefined,
): string {
  if (returnTo && ehRotaDeCheckout(returnTo) && temAssinaturaAtiva(billing)) {
    limparIntencaoDeCheckout();
    return PATHS.newOrder;
  }
  return returnTo || PATHS.newOrder;
}

function ehRotaDeCheckout(path: string): boolean {
  const pathname = path.split("?")[0];
  return pathname === PATHS.checkout || pathname.startsWith(`${PATHS.checkout}/`);
}
